<script lang="ts">
    import type {TabId} from 'shared/ui-widgets/tabset/types';
    import {Tab} from '@rgossiaux/svelte-headlessui';

    export let tabId: TabId;
    export let fullWidth = true;
    export let disabled = false;
    export let hidden = false;
    export let additionalClasses = '';
</script>

<Tab role="tab"
     disabled={disabled}
     data-tab={tabId}
     class="{({selected}) => `kp-generic-tab-item ${tabId} ${additionalClasses} ${selected ? 'selected' : ''} ${fullWidth ? 'full-width' : ''} ${hidden ? 'tabset-item-hidden' : ''}`}"
     on:click>

    <slot/>
</Tab>

<style lang="less">
    @import (reference) "bootstrap-less/bootstrap/variables";

    :global {
        .kp-generic-tab-item {
            padding: @padding-base-vertical @padding-large-horizontal;
            border-radius: @border-radius-base;
            background-color: @body-bg;
            outline: none;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: @padding-xs-horizontal;
            border: 1px solid transparent;
            color: @text-color;
            white-space: nowrap;
            transition: background-color 0.2s ease-in-out, border-color 0.2s ease-in-out;

            &.full-width {
                flex: 1;
            }

            &.selected {
                border-color: var(--selected-tab-highlight-color);
                color: var(--selected-tab-highlight-color);
                font-weight: 500;

                .text-muted {
                    font-weight: normal;
                }
            }

            &.tabset-item-hidden {
                display: none;
            }

            &:disabled {
                opacity: 0.5;
            }

            &:enabled:not(.selected) {
                border-color: @table-border-color;

                &:hover {
                    background-color: #E3E3E3;
                }
            }
        }
    }
</style>